import { customElement, property } from "lit/decorators.js";
import { html, TemplateResult } from "lit";
import { SavedAnnotation, savedAnnotationState } from "@/state/SavedAnnotations";
import { DodonaElement } from "@/components/meta/dodona_element";
import { I18n } from "@/i18n/i18n";

/**
 * Shows a link icon with some info on hover about the linked saved annotation
 *
 * @element d-saved-annotation-icon
 *
 * @prop {number} savedAnnotationId - The id of the saved annotation
 */
@customElement("d-saved-annotation-icon")
export class SavedAnnotationIcon extends DodonaElement {
    @property({ type: Number, attribute: "saved-annotation-id" })
    savedAnnotationId: number | null;

    private get savedAnnotation(): SavedAnnotation {
        if (this.savedAnnotationId == null) return null;
        return savedAnnotationState.get(this.savedAnnotationId);
    }

    render(): TemplateResult {
        const saved = this.savedAnnotation;
        if (!saved) return html``;

        const label = I18n.t("js.saved_annotation.new.linked", { title: saved.title });

        return html`
            <a href="${saved.url}" target="_blank" title="${label}" aria-label="${label}">
                <i class="mdi mdi-comment-bookmark-outline mdi-18 annotation-meta-icon" aria-hidden="true"></i>
                <span class="visually-hidden">${label}</span>
            </a>
        `;
    }
}
